export const premiumTranslations = {
  // I.S.C.A 3000
  "I.S.C.A 3000": {
    name: {
      en: "B.A.I.T 3000",
      es: "S.E.B.O 3000",
      zh: "高级诱饵3000"
    },
    description: {
      en: "A bait developed in Mjolnir's finest laboratories",
      es: "Un cebo desarrollado en los mejores laboratorios de Mjolnir",
      zh: "在姆乔尔尼尔最好的实验室研发的诱饵"
    }
  },

  // Frezzer Industrial
  "1 mês de Frezzer Industrial": {
    name: {
      en: "1 Month Industrial Freezer",
      es: "1 Mes de Congelador Industrial",
      zh: "1个月工业冷冻机"
    },
    description: {
      en: "Keep your fish always fresh, without losing value over time",
      es: "Mantén tus peces siempre frescos, sin perder valor con el tiempo",
      zh: "让鱼保持新鲜，随时间推移不会贬值"
    },
    tooltipText: {
      en: "Fish no longer spoil over time and can be sold at fresh prices",
      es: "Los peces ya no se estropean con el tiempo y se pueden vender a precios frescos",
      zh: "鱼不会随时间变质，可以以新鲜价格出售"
    }
  },
  "6 meses de Frezzer Industrial": {
    name: {
      en: "6 Months Industrial Freezer",
      es: "6 Meses de Congelador Industrial",
      zh: "6个月工业冷冻机"
    },
    description: {
      en: "Keep your fish always fresh, without losing value over time",
      es: "Mantén tus peces siempre frescos, sin perder valor con el tiempo",
      zh: "让鱼保持新鲜，随时间推移不会贬值"
    },
    tooltipText: {
      en: "Fish no longer spoil over time and can be sold at fresh prices",
      es: "Los peces ya no se estropean con el tiempo y se pueden vender a precios frescos",
      zh: "鱼不会随时间变质，可以以新鲜价格出售"
    }
  },
  "12 meses de Frezzer Industrial": {
    name: {
      en: "12 Months Industrial Freezer",
      es: "12 Meses de Congelador Industrial",
      zh: "12个月工业冷冻机"
    },
    description: {
      en: "Keep your fish always fresh, without losing value over time",
      es: "Mantén tus peces siempre frescos, sin perder valor con el tiempo",
      zh: "让鱼保持新鲜，随时间推移不会贬值"
    },
    tooltipText: {
      en: "Fish no longer spoil over time and can be sold at fresh prices",
      es: "Los peces ya no se estropean con el tiempo y se pueden vender a precios frescos",
      zh: "鱼不会随时间变质，可以以新鲜价格出售"
    }
  },

  // Tônicos
  "Tônico Revitalizante": {
    name: {
      en: "Revitalizing Tonic",
      es: "Tónico Revitalizante",
      zh: "复元补剂"
    },
    description: {
      en: "Restore your energy with the most powerful tonic in all of Odenlor",
      es: "Restaura tu energía con el tónico más poderoso de todo Odenlor",
      zh: "使用奥登洛尔最强大的补剂恢复你的能量"
    }
  },
  "Tônico da Sabedoria": {
    name: {
      en: "Wisdom Tonic",
      es: "Tónico de la Sabiduría",
      zh: "智慧补剂"
    },
    description: {
      en: "Developed by the greatest geniuses of Odenlor, it activates brain areas you didn't even know existed",
      es: "Desarrollado por los mayores genios de Odenlor, activa áreas del cerebro que ni siquiera conocías",
      zh: "由奥登洛尔最伟大的天才开发，激活你未知的大脑区域"
    }
  },
  "Tônico de Midas": {
    name: {
      en: "Midas Tonic",
      es: "Tónico de Midas",
      zh: "点金补剂"
    },
    description: {
      en: "Developed by the Goblin Kingdom, its effectiveness is magnificent, worthy of a goblin",
      es: "Desarrollado por el Reino Goblin, su eficacia es magnífica, digna de un goblin",
      zh: "由哥布林王国开发，效果惊人，堪称哥布林的杰作"
    }
  },
  "Tônico do Mestre Pescador": {
    name: {
      en: "Master Fisher's Tonic",
      es: "Tónico del Maestro Pescador",
      zh: "渔师大师补剂"
    },
    description: {
      en: "Created and designed by Marlim Inc., the largest fishing company in all of Odenlor",
      es: "Creado y diseñado por Marlim Inc., la mayor empresa pesquera de todo Odenlor",
      zh: "由奥登洛尔最大的渔业公司马林公司创造设计"
    }
  },

  // Revitalizator
  "1 mês Revitalizator 3000": {
    name: {
      en: "1 Month Revitalizator 3000",
      es: "1 Mes Revitalizador 3000",
      zh: "1个月活力恢复3000"
    },
    description: {
      en: "A machine that rejuvenates any tired fisherman",
      es: "Una máquina que rejuvenece a cualquier pescador cansado",
      zh: "一台能让疲惫渔民恢复活力的机器"
    },
    tooltipText: {
      en: "In addition to the rest bonus, you receive 6 more rest points per tick, which means that instead of recovering only 1 + house rest value, you receive +6",
      es: "Además del bono de descanso, recibes 6 puntos más de descanso por tick, lo que significa que en lugar de recuperar solo 1 + valor de descanso de la casa, recibes +6",
      zh: "除了休息加成外，每个周期还会获得额外6点休息点数，这意味着除了1+房屋休息值外，你还会获得+6点"
    }
  },
  "3 meses Revitalizator 3000": {
    name: {
      en: "3 Months Revitalizator 3000",
      es: "3 Meses Revitalizador 3000",
      zh: "3个月活力恢复3000"
    },
    description: {
      en: "A machine that rejuvenates any tired fisherman",
      es: "Una máquina que rejuvenece a cualquier pescador cansado",
      zh: "一台能让疲惫渔民恢复活力的机器"
    },
    tooltipText: {
      en: "In addition to the rest bonus, you receive 6 more rest points per tick, which means that instead of recovering only 1 + house rest value, you receive +6",
      es: "Además del bono de descanso, recibes 6 puntos más de descanso por tick, lo que significa que en lugar de recuperar solo 1 + valor de descanso de la casa, recibes +6",
      zh: "除了休息加成外，每个周期还会获得额外6点休息点数，这意味着除了1+房屋休息值外，你还会获得+6点"
    }
  },
  "6 meses Revitalizator 3000": {
    name: {
      en: "6 Months Revitalizator 3000",
      es: "6 Meses Revitalizador 3000",
      zh: "6个月活力恢复3000"
    },
    description: {
      en: "A machine that rejuvenates any tired fisherman",
      es: "Una máquina que rejuvenece a cualquier pescador cansado",
      zh: "一台能让疲惫渔民恢复活力的机器"
    },
    tooltipText: {
      en: "In addition to the rest bonus, you receive 6 more rest points per tick, which means that instead of recovering only 1 + house rest value, you receive +6",
      es: "Además del bono de descanso, recibes 6 puntos más de descanso por tick, lo que significa que en lugar de recuperar solo 1 + valor de descanso de la casa, recibes +6",
      zh: "除了休息加成外，每个周期还会获得额外6点休息点数，这意味着除了1+房屋休息值外，你还会获得+6点"
    }
  },
  "12 meses Revitalizator 3000": {
    name: {
      en: "12 Months Revitalizator 3000",
      es: "12 Meses Revitalizador 3000",
      zh: "12个月活力恢复3000"
    },
    description: {
      en: "A machine that rejuvenates any tired fisherman",
      es: "Una máquina que rejuvenece a cualquier pescador cansado",
      zh: "一台能让疲惫渔民恢复活力的机器"
    },
    tooltipText: {
      en: "In addition to the rest bonus, you receive 6 more rest points per tick, which means that instead of recovering only 1 + house rest value, you receive +6",
      es: "Además del bono de descanso, recibes 6 puntos más de descanso por tick, lo que significa que en lugar de recuperar solo 1 + valor de descanso de la casa, recibes +6",
      zh: "除了休息加成外，每个周期还会获得额外6点休息点数，这意味着除了1+房屋休息值外，你还会获得+6点"
    }
  },

  // Pacote e Tickets
  "Pacote do jovem pescador": {
    name: {
      en: "Young Fisher's Package",
      es: "Paquete del Joven Pescador",
      zh: "年轻渔夫礼包"
    },
    description: {
      en: "Young Fisher's Package",
      es: "Paquete del Joven Pescador",
      zh: "年轻渔夫礼包"
    },
  },
  "5 tickets": {
    name: {
      en: "5 Tickets",
      es: "5 Tickets",
      zh: "5张券"
    },
    description: {
      en: "5 Tickets",
      es: "5 Tickets",
      zh: "5张券"
    }
  },
  "10 tickets": {
    name: {
      en: "10 Tickets",
      es: "10 Tickets",
      zh: "10张券"
    },
    description: {
      en: "10 Tickets",
      es: "10 Tickets",
      zh: "10张券"
    }
  },
  "25 tickets": {
    name: {
      en: "25 Tickets",
      es: "25 Tickets",
      zh: "25张券"
    },
    description: {
      en: "25 Tickets",
      es: "25 Tickets",
      zh: "25张券"
    }
  },

  // Baús
  "Baú de madeira": {
    name: {
      en: "Wooden Chest",
      es: "Cofre de Madera",
      zh: "木制宝箱"
    },
    description: {
      en: "The chest for those who want to start",
      es: "El cofre para los que quieren empezar",
      zh: "适合新手的宝箱"
    },
    tooltipText: {
      en: "Chances of winning:| 50% Worm (10-25 units)|30% Coins (300-1000)|15% B.A.I.T 3000 (2-4)|5% Night Fisher Rod",
      es: "Probabilidades de ganar:| 50% Lombriz (10-25 unidades)|30% Monedas (300-1000)|15% S.E.B.O 3000 (2-4)|5% Caña del Pescador Nocturno",
      zh: "获得概率:| 50% 蚯蚓 (10-25个)|30% 金币 (300-1000)|15% 高级诱饵3000 (2-4)|5% 夜钓者鱼竿"
    }
  },
  "Caixote de Aço": {
    name: {
      en: "Steel Chest",
      es: "Cofre de Acero",
      zh: "钢制宝箱"
    },
    description: {
      en: "The chest for intermediate fishermen",
      es: "El cofre para pescadores intermedios",
      zh: "适合中级渔民的宝箱"
    },
    tooltipText: {
      en: "Chances of winning:| 50% Cricket (10-25 units)|30% Coins (1000-4000)|15% B.A.I.T 3000 (3-6)|5% Deep Ocean Rod",
      es: "Probabilidades de ganar:| 50% Grillo (10-25 unidades)|30% Monedas (1000-4000)|15% S.E.B.O 3000 (3-6)|5% Caña del Océano Profundo",
      zh: "获得概率:| 50% 蟋蟀 (10-25个)|30% 金币 (1000-4000)|15% 高级诱饵3000 (3-6)|5% 深海鱼竿"
    }
  },
  "Baú Naúfragado": {
    name: {
      en: "Shipwrecked Chest",
      es: "Cofre Naufragado",
      zh: "沉船宝箱"
    },
    description: {
      en: "A chest found in an ancient shipwreck, must contain interesting things",
      es: "Un cofre encontrado en un naufragio antiguo, debe contener cosas interesantes",
      zh: "在古代沉船中发现的宝箱，一定藏有有趣的东西"
    },
    tooltipText: {
      en: "Chances of winning:| 50% Cricket (40-75 units)|30% Coins (6500-18000)|15% B.A.I.T 3000 (10-15)|5% Leviathan Rod",
      es: "Probabilidades de ganar:| 50% Grillo (40-75 unidades)|30% Monedas (6500-18000)|15% S.E.B.O 3000 (10-15)|5% Caña del Leviatán",
      zh: "获得概率:| 50% 蟋蟀 (40-75个)|30% 金币 (6500-18000)|15% 高级诱饵3000 (10-15)|5% 利维坦鱼竿"
    }
  },
  "Baú Kraken": {
    name: {
      en: "Kraken Chest",
      es: "Cofre del Kraken",
      zh: "海妖宝箱"
    },
    description: {
      en: "They say it was taken from the treasure protected by the Kraken itself, be careful when opening!",
      es: "Dicen que fue sacado del tesoro protegido por el propio Kraken, ¡cuidado al abrirlo!",
      zh: "据说是从克拉肯亲自守护的宝藏中取出的，打开时要小心！"
    },
    tooltipText: {
      en: "Chances of winning:| 50% Shrimp (40-75 units)|30% Coins (35000-80000)|15% B.A.I.T 3000 (40-70)|5% Triton Rod",
      es: "Probabilidades de ganar:| 50% Camarón (40-75 unidades)|30% Monedas (35000-80000)|15% S.E.B.O 3000 (40-70)|5% Caña del Tritón",
      zh: "获得概率:| 50% 虾 (40-75个)|30% 金币 (35000-80000)|15% 高级诱饵3000 (40-70)|5% 海神三叉戟鱼竿"
    }
  },
  "Baú de Poseidon": {
    name: {
      en: "Poseidon's Chest",
      es: "Cofre de Poseidón",
      zh: "波塞冬宝箱"
    },
    description: {
      en: "Stolen from Poseidon's personal collection, I can't even imagine the secrets it must contain",
      es: "Robado de la colección personal de Poseidón, ni me imagino los secretos que debe contener",
      zh: "从波塞冬的私人收藏中偷来的，里面一定藏有无法想象的秘密"
    },
    tooltipText: {
      en: "Chances of winning:| 50% Shrimp (250-400 units)|30% Coins (70000-190000)|15% B.A.I.T 3000 (75-130)|5% Destiny Rod",
      es: "Probabilidades de ganar:| 50% Camarón (250-400 unidades)|30% Monedas (70000-190000)|15% S.E.B.O 3000 (75-130)|5% Caña del Destino",
      zh: "获得概率:| 50% 虾 (250-400个)|30% 金币 (70000-190000)|15% 高级诱饵3000 (75-130)|5% 命运鱼竿"
    }
  }
};
